const Routes = [
  {
    path: '/store-growth',
    name: 'storeGrowth',
    component: () => import('@/app/store_growth/TheStoreGrowth'),
    redirect: '/store-growth/stores-without-growth',
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: 'stores-without-growth',
        component: () => import('@/app/store_growth/views/StoresWithoutGrowth'),
        name: 'storesWithoutGrowth'
      },
      {
        path: 'stores-without-growth/:storeId',
        component: () => import('@/app/store_growth/views/StoresWithoutGrowthDetail'),
        name: 'storesWithoutGrowthDetail',
        props: (route) => ({
          ...route.params,
          storeId: parseInt(route.params.storeId)
        })
      }
    ]
  }
]

export default Routes



// WEBPACK FOOTER //
// ./src/app/store_growth/Routes.js